/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import { components } from 'react-select';
import {
  ArrowIcon,
  ErrorMessage,
  IconWrapper,
  RequiredAsterisk,
  SelectLabel,
  SelectWrapper,
  StyledSelect,
} from './common-select-style';

const CommonSelect = ({
  label,
  placeholder = 'Selecione uma opção',
  value,
  onChange,
  options = [],
  icon,
  required = false,
  name,
  disabled = false,
  error,
  onBlur,
  ...props
}) => {

  const formattedOptions = options.map((opt) => ({
    value: opt.id,
    label: opt.value,
  }));

  const selectedOption = formattedOptions.find((opt) => opt.value === value) || null;

  const handleChange = (option) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: option?.value || '',
        },
      });
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur({
        target: {
          name,
          value,
        },
      });
    }
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowIcon
          $isDisabled={disabled}
          $isOpen={props.selectProps.menuIsOpen}
        >
          ▼
        </ArrowIcon>
      </components.DropdownIndicator>
    );
  };

  const ValueContainer = ({ children, ...props }) => {
    return (
      <components.ValueContainer {...props}>
        {icon && (
          <IconWrapper $isDisabled={disabled}>
            {icon}
          </IconWrapper>
        )}
        {children}
      </components.ValueContainer>
    );
  };

  return (
    <SelectWrapper>
      {label && (
        <SelectLabel>
          {label}
          {required && <RequiredAsterisk> *</RequiredAsterisk>}
        </SelectLabel>
      )}

      <StyledSelect
        classNamePrefix="react-select"
        name={name}
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        isDisabled={disabled}
        hasError={!!error}
        components={{
          DropdownIndicator,
          ValueContainer,
        }}
        isClearable={false}
        isSearchable={false}
        noOptionsMessage={() => 'Nenhuma opção para selecionar'}
        {...props}
      />

      {error && <ErrorMessage>{error}</ErrorMessage>}
    </SelectWrapper>
  );
};

export default CommonSelect;
